import uniq from 'lodash/uniq';
import {getCategoryFromMainCategories, getMenuEntry} from 'helpers/menu.helper';
import {getModifiersPrice} from 'helpers/modifier.helper';
import {CartItem, OrderLine} from 'helpers/order-line.helper.types.ts';
import {Menu, MainCategory, Category} from 'helpers/menu.helper.types.ts';
import {MenuEntryModifierSelections, ModifierGroup} from './modifier.helper.types';

export const getCartItems = (currentOrderLines: Array<OrderLine> = [], currentMenu: Menu): Array<CartItem> => {
	if(!currentMenu) return [];
	
	return currentOrderLines
		.map(orderLine => {
			const menuEntry = getMenuEntry(currentMenu.menu.menu, orderLine.menuEntryId);

			if (!menuEntry) {
				return null;
			}

			return {
				token: orderLine.token,
				mainCategoryId: menuEntry.mainCategoryId,
				categoryId: menuEntry.categoryId,
				menuEntryId: orderLine.menuEntryId,
				quantity: orderLine.quantity,
				name: menuEntry.name,
				price: menuEntry.price,
				modifierGroups:
					menuEntry.modIds &&
					currentMenu.menu.modifierGroups.filter(modifierGroup =>
						menuEntry.modIds.includes(modifierGroup.modifierGroupId)
					),
				modifierSelections: orderLine.modifierSelections,
			};
		})
		.filter(cartItem => !!cartItem);
};


export const getCartMainCategories = (cartItems: Array<CartItem>, currentMenu: Menu): Array<MainCategory> => {
	return uniq(cartItems.map(cartItem => cartItem.mainCategoryId)).map(mainCategoryId =>
		currentMenu.menu.menu.find(mainCategory => mainCategory.id === mainCategoryId)
	);
};

export const getCartCategories = (cartItems: Array<CartItem>, currentMenu: Menu): Array<Category> => {
	return uniq(cartItems.map(cartItem => cartItem.categoryId)).map(categoryId =>
		getCategoryFromMainCategories(currentMenu.menu.menu, categoryId)
	);
};

export const getMenuEntryTotalPrice = (entryPrice: number, quantity: number, modifierGroups: Array<ModifierGroup>, modifierSelections: MenuEntryModifierSelections): number => {
	return (entryPrice + getModifiersPrice(modifierGroups, modifierSelections)) * quantity;
};

export const getCartItemSum = (cartItems: Array<CartItem>): number => {
	return cartItems.reduce(
		(accum, cartItem) =>
			accum +
			getMenuEntryTotalPrice(cartItem.price, cartItem.quantity, cartItem.modifierGroups, cartItem.modifierSelections),
		0
	);
};

export const getCartDiscount = (cartItems: Array<CartItem>, deliveryConditions, currentServerValues): number => {
	//TODO add param types

	if (!currentServerValues.discountPrice) {
		return 0;
	}

	return -(getCartItemSum(cartItems) + (deliveryConditions?.price || 0) - (currentServerValues.discountPrice || 0));
};
